// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PublicExposureIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PublicExposureIcon" ref={forwardedRef} {...props}>
      <path d="M6.234 17.06a8 8 0 1 1 11.64-5.635L16.19 8.317A14 14 0 0 0 15.604 7.3l-.033-.05h.32a6.52 6.52 0 0 0-4.152-3.515 12 12 0 0 1 1.513 2.377 2.5 2.5 0 0 0-.818.226 2.2 2.2 0 0 0-.555.379A10.4 10.4 0 0 0 10 4.035 10.4 10.4 0 0 0 7.883 7.25h3.546l-.033.049a14 14 0 0 0-.586 1.018L10.575 8.75H7.418L7.37 8.99a7.5 7.5 0 0 0-.028 2.51h1.743L8.273 13H7.746a8 8 0 0 0 .23.548l-.858 1.584A10 10 0 0 1 6.16 13H4.232a6.53 6.53 0 0 0 2.593 2.673 11 11 0 0 0-.393.787 3.2 3.2 0 0 0-.198.6m-2.56-5.56h2.153A9 9 0 0 1 5.89 8.75H3.62a6.5 6.5 0 0 0 .054 2.75M6.28 7.25a11.6 11.6 0 0 1 1.981-3.515A6.52 6.52 0 0 0 4.109 7.25z" />
      <path d="M13 12h1v2.5h-1z" />
      <path d="M12.875 15.863a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0" />
      <path d="M12.102 9.081c.45-.83.675-1.246.972-1.386a1 1 0 0 1 .852 0c.297.14.522.555.972 1.386l3.83 7.072c.415.765.622 1.147.587 1.46a1 1 0 0 1-.421.707C18.636 18.5 18.2 18.5 17.33 18.5H9.67c-.87 0-1.306 0-1.564-.18a1 1 0 0 1-.42-.707c-.036-.313.17-.695.585-1.46zM17.482 17 13.5 9.65 9.518 17zm.355.709.003.008v-.003z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PublicExposureIcon = /* @__PURE__ */ Object.assign(
  PublicExposureIconComponent,
  { displayName: 'PublicExposureIcon' },
);
